import getBaseUrl from './getBaseUrl.js';

export default async function getAppConfig() {
  const baseUrl = getBaseUrl();

  const response = await fetch(`${baseUrl}/app-config`, {
    headers: {
      Accept: 'application/json',
      'Accept-encoding': 'gzip',
      'Content-type': 'application/json; charset=UTF-8'
    },
    method: 'GET'
  });

  if (!response.ok) {
    throw Object.assign(new Error(response.statusText), { response: { status: response.status } });
  }

  const config = await response.json();
  return config;
}
